import ProfileSubstitutesTab from '@/features/profile/ProfileSubstitutesTab';

const Vocabulary = () => (
  <ProfileSubstitutesTab
    type="vocabulary"
    mode="vocabulary"
    titleKey="profile.tabs.vocabulary"
    descriptionKey="profile.vocabulary.description"
    addButtonKey="profile.vocabulary.addButton"
  />
);

export default Vocabulary;
